// can't backward compatible,
// please update it if you want to backward compatible
// Capacitance Pressure Id : Source : 0 ,vacuum :1, Bottle:2
// Load cell Pressure Id : SOURCE : 0, VACUUM : 1,BOTTLE : 3,DIAPHRAGM : 2
import * as FIELD_NAME from './fieldNames';

export const MANUAL_CONTROL_THRESHOLD_OPTION = [
  {value: '0', label: '0'},
  {value: '0.5', label: '0.5'},
  {value: '1', label: '1'},
  {value: '2.5', label: '2.5'},
  {value: '5', label: '5'},
];

export const ADVANCE_SETUP_RESTRICTION = {
  [FIELD_NAME.SOURCE_PRESSURE]: {
    DECIMAL_PLACE_ACCURACY: 1,
    MAX_VALUE: 60,
    MIN_VALUE: 30,
    INFO: undefined,
  },
  [FIELD_NAME.VACUUM_PRESSURE]: {
    DECIMAL_PLACE_ACCURACY: 3,
    MAX_VALUE: 0,
    // MIN_VALUE: -9.25,
    MIN_VALUE: -12,
    INFO: undefined,
  },
  // Return Valve Pressure
  [FIELD_NAME.BOTTLE_PRESSURE]: {
    DECIMAL_PLACE_ACCURACY: 1,
    MAX_VALUE: 21,
    MIN_VALUE: 0,
    INFO: undefined,
  },
  [FIELD_NAME.DIAPHRAGM_PRESSURE]: {
    DECIMAL_PLACE_ACCURACY: 1,
    MAX_VALUE: 50,
    MIN_VALUE: 10,
    INFO: undefined,
  },
  [FIELD_NAME.DIAPHRAGM_FILL_TIME]: {
    DECIMAL_PLACE_ACCURACY: 1,
    MAX_VALUE: 1000, // ushort max number (backend)
    MIN_VALUE: 50,
    INFO: undefined,
  },
  [FIELD_NAME.DIAPHRAGM_EMPTY_TIME]: {
    DECIMAL_PLACE_ACCURACY: 1,
    MAX_VALUE: 1000, // ushort max number (backend)
    MIN_VALUE: 50,
    INFO: undefined,
  },
  [FIELD_NAME.VALVE_TIMING]: {
    DECIMAL_PLACE_ACCURACY: 1,
    MAX_VALUE: 50,
    MIN_VALUE: 10,
    INFO: undefined,
  },
  [FIELD_NAME.MEMBRANE_FILLING_CYCLE]: {
    DECIMAL_PLACE_ACCURACY: 1,
    MAX_VALUE: 40,
    MIN_VALUE: 10,
    INFO: undefined,
  },
};
